import { ILogger } from '@qest/logger-utils'

export default class DevelopmentLogger implements ILogger {
  debug(msg: string | object | Error, ...args: any[]) {
    console.debug(msg, args)
  }

  error(msg: string | object | Error, ...args: any[]) {
    console.error(msg, args)
  }

  fatal(msg: string | object | Error, ...args: any[]) {
    console.error(msg, args)
  }

  info(msg: string | object | Error, ...args: any[]) {
    console.info(msg, args)
  }

  trace(msg: string | object | Error, ...args: any[]) {
    console.trace(msg, args)
  }

  warn(msg: string | object | Error, ...args: any[]) {
    console.warn(msg, args)
  }
}
